import React from "react";
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../components/AuthLayout';
import { ForgotPasswordForm } from '../components/ForgotPasswordForm';

export const ForgotPassword = () => {
  const { t } = useTranslation();

  return (
    <AuthLayout title={t('website:auth.forgotPassword.heading')}>
      <ForgotPasswordForm />
    </AuthLayout>
  );
};
